import type { ReactNode } from 'react';
import { FormattedMessage, type MessageDescriptor } from 'react-intl';
import styled from 'styled-components';

import { ContentWithStickyHeader } from '@sorare/core/src/atoms/layout/ContentWithStickyHeader';
import { Tab, TabBar } from '@sorare/core/src/atoms/navigation/TabBar';
import { useIsDesktopAndAbove } from '@sorare/core/src/hooks/device/useIsDesktopAndAbove';

const StyledTabBar = styled(TabBar)`
  flex-grow: 1;
  margin: var(--double-unit);
  min-height: var(--quadruple-unit);
  &.segmented {
    --active-bg-color: var(--c-nd-150);
    --button-border: 1px solid var(--c-nd-150);
    --active-fg-color: var(--c-white);
    --active-button-border: 1px solid var(--c-nd-150);
  }
`;

const TopRight = styled.div`
  position: absolute;
  right: var(--quadruple-unit);
  top: var(--double-unit);
`;

export const MySorareSubTabsLayout = ({
  tabs,
  children,
}: {
  tabs: {
    to: string;
    label: MessageDescriptor;
    icon?: React.ReactNode;
  }[];
  children: ReactNode;
}) => {
  const isDesktop = useIsDesktopAndAbove();
  if (tabs.length === 0 && !isDesktop) {
    return <>{children}</>;
  }
  return (
    <ContentWithStickyHeader
      header={
        <>
          <StyledTabBar variant="segmented">
            {tabs.map(tab => (
              <Tab key={tab.to} to={tab.to}>
                {tab.icon}
                <FormattedMessage {...tab.label} />
              </Tab>
            ))}
          </StyledTabBar>
          <TopRight id="my-sorare-filters" />
        </>
      }
    >
      {children}
    </ContentWithStickyHeader>
  );
};
